import svgPaths from "./svg-yf7bfxiz3f";

export default function Vector() {
  return (
    <div className="relative size-full" data-name="Vector">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 12 21">
        <path d={svgPaths.p27596280} fill="var(--fill-0, white)" id="Vector" />
      </svg>
    </div>
  );
}